var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9961 17.5003V32.5003M18.9961 17.5003L14.8294 20.8336M18.9961 17.5003L23.1628 20.8336M7.38611 12.6953C5.8098 13.092 4.43257 14.0506 3.5132 15.391C2.59383 16.7315 2.19558 18.3616 2.39329 19.975C2.591 21.5883 3.37105 23.074 4.58689 24.1528C5.80273 25.2316 7.37066 25.8293 8.99611 25.8336H10.6628",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3825 9.39489C24.8128 7.13918 23.4068 5.18446 21.4493 3.92699C19.4919 2.66952 17.1296 2.20338 14.8412 2.62307C12.5529 3.04276 10.5097 4.31687 9.1259 6.18713C7.7421 8.05738 7.12123 10.3838 7.38913 12.6949C7.38913 12.6949 7.64413 14.1649 8.16579 14.9982",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3307 25.8307C28.5075 25.8299 29.6707 25.5799 30.7438 25.0972C31.817 24.6144 32.7757 23.9098 33.5569 23.0299C34.3382 22.1499 34.9242 21.1144 35.2764 19.9916C35.6286 18.8688 35.739 17.6842 35.6004 16.5156C35.4617 15.3471 35.0772 14.2212 34.472 13.212C33.8669 12.2028 33.0549 11.3331 32.0895 10.6604C31.124 9.9876 30.027 9.52692 28.8707 9.30866C27.7144 9.0904 26.525 9.11951 25.3807 9.39406L23.1641 9.99739",
    stroke: "#BABABA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.386a2b0e0ff86ff33537841f525c3d57.svg";
export { ForwardRef as ReactComponent };